module.exports = __webpack_public_path__ + "static/media/dont-panic-kolsch.81dd36ab.webp";